export default {
  name: 'app-menu',
  data () {
    return {
      activeIndex: null
    }
  },
  props: {
    menu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      let menuCurrentItem = this.$store.getters.appHeaderMenuCurrentItem
      if (menuCurrentItem) {
        this.activeIndex = menuCurrentItem
      } else {
        if (this.menu) {
          for (let i = 0; i < this.menu.length; ++i) {
            if (this.$route.path.indexOf(this.menu[i].key) !== -1) {
              this.activeIndex = this.menu[i].key
              break
            }
          }
        }
      }
    })
  },
  methods: {
    // 根据菜单项路径,返回菜单项
    getMenuItemByPath(key, menu) {
      for (let i = 0; i < menu.length; i++) {
        if (menu[i].key === key) {
          return menu[i]
        } else {
          let menuItem = null
          if (menu[i].children.length > 0) {
            menuItem = this.getMenuItemByPath(key, menu[i].children)
            if (menuItem) {
              return menuItem
            }
          }
        }
      }
      return null
    },
    handleSelect (key) {
      // 获取query
      let query = ''
      let menuItem = this.getMenuItemByPath(key, this.menu)
      if (menuItem) {
        query = menuItem.query
      }

      this.$store.commit('app/SET_HEADER_MENU_CURRENT_ITEM', key)
      this.$store.commit('app/SET_HEADER_MENU_CURRENT_ITEM_QUERY', query)
      if (query) {
        this.$router.push({ path: '/' + key, query: JSON.parse(query) })
      } else {
        this.$router.push({ path: '/' + key })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/appMenu/AppMenu.js